import { event as gtagEvent } from 'vue-gtag';

/** GA4が有効な場合のみイベントを送信するラッパー */
export const trackEvent = (name: string, params?: Record<string, unknown>): void => {
    if (!import.meta.env.PROD || !import.meta.env.VITE_GA_MEASUREMENT_ID) return;
    gtagEvent(name, params);
};
